import { AUDIO_PRECACHE_NAME, VIDEO_PRECACHE_NAME, IMAGES_PRECACHE_NAME } from '../../config/precache';

export const downloadAudio = async (experience) => {
  const { config } = experience;
  if (!config?.audio?.sounds || config.audio.sounds.length === 0) return;

  try {
    const audioUrls = config.audio?.sounds?.map((audio) => audio.url) || [];
    const cache = await caches.open(AUDIO_PRECACHE_NAME);
    const results = await Promise.allSettled(
      audioUrls.map(async (url) => {
        await cache.delete(url, {
          ignoreVary: true,
          ignoreSearch: true,
        });
        return fetch(url).then((response) => {
          if (!response.ok) {
            console.error('Cannot load audio url', url);
            throw Error('Cannot load audio url', url);
          }
          return cache.put(url, response);
        });
      })
    );
    if (results.find((result) => result.status !== 'fulfilled')) {
      console.error('Error caching audio files');
      return { error: 'Error caching audio files' };
    }

    console.info('Audio files cached successfully');
  } catch (e) {
    console.error('Error caching audio files', e);
    return { error: 'Error caching audio files' };
  }
};

export const downloadVideo = async (experience) => {
  const { config } = experience;
  if (!config?.video?.videos || config.video.videos.length === 0) return;

  try {
    const videoUrls = config.video?.videos?.map((video) => video.url) || [];
    const cache = await caches.open(VIDEO_PRECACHE_NAME);
    const results = await Promise.allSettled(
      videoUrls.map(async (url) => {
        await cache.delete(url, {
          ignoreVary: true,
          ignoreSearch: true,
        });
        return fetch(url).then((response) => {
          if (!response.ok) {
            console.error('Cannot load video url', url);
            throw Error('Cannot load video url', url);
          }
          return cache.put(url, response);
        });
      })
    );
    if (results.find((result) => result.status !== 'fulfilled')) {
      console.error('Error caching video files');
      return { error: 'Error caching video files' };
    }

    console.info('Video files cached successfully');
  } catch (e) {
    console.error('Error caching video files', e);
    return { error: 'Error caching video files' };
  }
};

export const downloadCredits = async (experience) => {
  if (!experience.creditsEnabled || experience.creditsBlocks?.length === 0) return;
  const credits = experience.creditsBlocks;

  try {
    const imageUrls =
      credits
        .filter((block) => block && block?.type === 'images' && block.images)
        .flatMap((block) => block.images?.map((image) => image.url)) || [];

    const cache = await caches.open(IMAGES_PRECACHE_NAME);
    const results = await Promise.allSettled(
      imageUrls.map(async (url) => {
        await cache.delete(url, {
          ignoreVary: true,
          ignoreSearch: true,
        });
        return fetch(url).then((response) => {
          if (!response.ok) {
            console.error('Cannot load image url', url);
            throw Error('Cannot load image url', url);
          }
          return cache.put(url, response);
        });
      })
    );
    if (results.find((result) => result.status !== 'fulfilled')) {
      console.error('Error caching image files');
      return { error: 'Error caching image files' };
    }

    console.info('Image files cached successfully');
  } catch (e) {
    console.error('Error caching image files', e);
    return { error: 'Error caching image files' };
  }
};
